import { graphql, useStaticQuery } from "gatsby";
import { ReadyToHireQuery } from "../../../graphql-types";
import { pp } from "../../shared/utilities/pretty-print";

export function useReadyToHireImageQuery() {
  const data = useStaticQuery(graphql`
    query ReadyToHire {
      staticImagesJson {
        images {
          womanCookingWithDaughter {
            fluid {
              ...CloudinaryAssetFluid_noBase64
            }
          }
        }
      }
    }
  `) as ReadyToHireQuery;
  // for some reason I can not update this in graphql-types to ReadyToHireImageQuery
  if (data.staticImagesJson?.images?.womanCookingWithDaughter?.fluid == null) {
    throw Error(
      `data.staticImagesJson?.images?.womanCookingWithDaughter?.fluid is null: ` +
        `${pp({ data })}}`
    );
  }
  const womanCookingWithDaughterFluid =
    data.staticImagesJson.images.womanCookingWithDaughter.fluid;
  return womanCookingWithDaughterFluid;
}
